module.exports = __webpack_public_path__ + "img/三木集团.8156f4ae.png";